/**
 * Discrimination entre signout VOLONTAIRE (l'arbitre a clique « Deconnexion »)
 * et signout INVOLONTAIRE (token expire, storage purge par Safari ITP,
 * cookies effaces par l'utilisateur, etc.).
 *
 * Le flag est pose AVANT l'appel a `supabase.auth.signOut()` cote logout
 * UI, puis consomme par l'AuthContext lors du SIGNED_OUT. Si le flag est
 * present -> redirect normale (UX classique). Sinon -> on declenche
 * l'auto-recovery magic link.
 *
 * Stockage : localStorage uniquement (sync, pas besoin de la robustesse
 * IDB ici — un signout intentionnel + une purge ITP simultanee est trop
 * improbable pour justifier la complexite, et si ca arrivait, l'arbitre
 * recevrait un magic link non sollicite mais innofensif).
 *
 * Cle versionnee pour permettre des migrations futures.
 */
const INTENTIONAL_SIGNOUT_KEY = "gsf:intentional-signout:v1";

export function markIntentionalSignout(): void {
  try {
    window.localStorage.setItem(INTENTIONAL_SIGNOUT_KEY, "1");
  } catch {
    /* swallow — si localStorage refuse, le flag absent fera supposer
       un signout involontaire, ce qui declenchera l'auto-recovery,
       mais comme l'utilisateur vient d'agir explicitement, le magic
       link sera envoye et sera juste un mail de plus a ignorer. */
  }
}

/** Lit + supprime le flag en une operation atomique. */
export function consumeIntentionalSignout(): boolean {
  try {
    const v = window.localStorage.getItem(INTENTIONAL_SIGNOUT_KEY);
    if (v) {
      window.localStorage.removeItem(INTENTIONAL_SIGNOUT_KEY);
      return true;
    }
  } catch {
    /* swallow */
  }
  return false;
}
